import * as React from 'react'
import { observer } from 'mobx-react'
import ExternalDataSearchByPhoneView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByPhoneView'
import ExternalDataSearchByPINView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByPINView'
import ExternalDataSearchByPassportView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByPassportView'
import ExternalDataSearchByCreditNumberView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByCreditNumberView'
import ExternalDataSearchByNameView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByNameView'
import ExternalDataSearchByBDayView
    from '../../PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByBDayView'

@observer
export default class ExternalDataSearchPage extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div className="searchPage">
                <ExternalDataSearchByPhoneView />
                <ExternalDataSearchByPINView />
                <ExternalDataSearchByCreditNumberView />
                <ExternalDataSearchByPassportView />
                <ExternalDataSearchByNameView />
                <ExternalDataSearchByBDayView />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataSearchPage.tsx